export { news2Bounds, news2RiskScale } from './news2-risk';
export { pulseRate, pulseRateBounds } from './pulse-rate';
export { respirationRate, respirationRateBounds } from './respiration-rate';
export { spo2Scale1, spo2Scale1Bounds } from './spo2-scale-1';
export { spo2Scale2Air, spo2Scale2AirBounds } from './spo2-scale-2-air';
export {
  spo2Scale2Oxygen,
  spo2Scale2OxygenBounds,
} from './spo2-scale-2-oxygen';
export {
  systolicBloodPressure,
  systolicBloodPressureBounds,
} from './systolic-blood-pressure';
export { temperature, temperatureBounds } from './temperature';
